import React, { FC, useEffect, useState } from "react";
import {
  Stack,
  Box,
  Typography,
  Button,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import useResponsive from "../../hooks/useResponsive";
import Header from "../../layout/dashboard/header";
import { useMutation } from "@tanstack/react-query";

import { useAuth } from "../../hooks/useAuth";
import { useNotificationService } from "../../components/notification";
import UserManagementContent from "../../components/users/UsersManagement";
import { apiGetUsers } from "../../api/users";
import { UsersDataProps } from "../../interface/users";
import { CreateUsers } from "../../components/users/modal-users";
import { PaginationDetails, PaginationDetailsDummyData } from "../../interface/api_request";

const UserManagement: React.FC = () => {
  const theme = useTheme();
  const { token } = useAuth();
  const { showNotification } = useNotificationService();
  const isMedium = useResponsive("down", "md", "xl");
  const isSmall = useResponsive("down", "sm", "xl");
  const [users_list, setUsers_list] = useState<UsersDataProps[]>([]);
  const [open, setOpen] = useState(false);

  // set up pagination state
  const [pagination_state, setPagination_state] = useState<PaginationDetails>(
    PaginationDetailsDummyData
  );

  const handleModal = () => {
    setOpen(!open);
  };

  useEffect(() => {
    mutation.mutate();
  }, [pagination_state?.page]);

  const mutation = useMutation({
    mutationFn: () => apiGetUsers(token),
    onSuccess: (data) => {
      if (data?.status === "error") {
        if ("msg" in data) {
          showNotification(data?.msg ?? "", "error");
          return;
        }
        return;
      }
      
      if ("data" in data) {
        if (!!data?.data?.meta) {
          
          setPagination_state({
            hasNextPage: data?.data?.meta?.hasNextPage,
            hasPrevPage: data?.data?.meta?.hasPrevPage,
            nextPage: data?.data?.meta?.nextPage,
            page: data?.data?.meta?.page,
            pages: data?.data?.meta?.pages,
            prevPage: data?.data?.meta?.prevPage,
            reads: data?.data?.meta?.reads,
            totalDocs: data?.data?.meta?.totalDocs,
            unReads: data?.data?.meta?.unReads,
          });
        }
        if (data?.data?.data?.length > 0) {
          setUsers_list(data?.data?.data);
        } else {
          setUsers_list([]);
        }
      }
    },
    onError: (error) => {
      console.error("Fetch user details failed", error);
      showNotification("Fetch user details failed", "error");
    },
  });
  return (
    <>
      {/* Header Menu */}
      <Header>
        <Box
          sx={{
            flexGrow: 1,
            display: "flex",
            flexDirection: "row",
            gap: "10px",
            justifyContent: "space-between",
            alignItems: "center",
            marginRight: "1rem",
            height: isMedium ? 60 : 75,
          }}
        >
          <Stack direction={"row"} alignItems={"center"} sx={{ gap: "10px" }}>
            <Typography
              variant={"subtitle1"}
              sx={{
                fontWeight: 500,
                fontFamily: "Lexend",
                color: theme.palette.secondary.dark,
              }}
            >
              Admin Management
            </Typography>
          </Stack>
          {!isSmall && (
            <Stack direction={"row"} sx={{ gap: 3 }}>
              <Button
                variant="outlined"
                onClick={handleModal}
                sx={{
                  padding: "4px 12px",
                  height: isMedium ? "35px" : "40px",
                  fontWeight: 700,
                  fontFamily: "DM Sans",
                }}
              >
                Create User
              </Button>
              {/* <Button
                onClick={() => navigate(PATH_USER.permissions)}
                variant="outlined"
                sx={{
                  padding: "4px 12px",
                  height: isMedium ? "35px" : "40px",
                  fontWeight: 700,
                  fontFamily: "DM Sans",
                }}
              >
                Create Role
              </Button> */}
            </Stack>
          )}
        </Box>
      </Header>
      <CreateUsers open={open} handleModal={handleModal} />

      <UserManagementContent
        usersList={users_list}
        isLoading={mutation.isPending}
        paginationState={pagination_state}
        setPaginationState={setPagination_state}
      />
    </>
  );
};

export default UserManagement;
